import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiEnvelope } from '../../models/auth.dto';
import { TraceEventsResponse } from '../../models/trace.dto';

@Injectable({ providedIn: 'root' })
export class TraceService {
  private apiUrl = environment.cbdx_service.api_path;

  constructor(private http: HttpClient) {}

  /**
   * `companyId` is ignored by the backend for a company-scoped caller (always traces as its own
   * company) and required for a SUPERADMIN, who has none of its own — see `GET /api/traces`.
   */
  trace(
    epc: string,
    includeRecalled = false,
    companyId?: string
  ): Observable<ApiEnvelope<TraceEventsResponse>> {
    let params = new HttpParams().set('epc', epc).set('includeRecalled', includeRecalled);
    if (companyId) {
      params = params.set('companyId', companyId);
    }
    return this.http.get<ApiEnvelope<TraceEventsResponse>>(`${this.apiUrl}/traces`, { params });
  }
}
